module.exports = __webpack_public_path__ + "img/active.f2075170.png";